// App.js
import React, { useState, useEffect } from "react";
import { Routes, Route, useLocation, Navigate } from "react-router-dom";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import "./Styles/App.css";
import "./Styles/CalmTheme.css";
import Main from "./1_Mainpage.js";
import Clebine from "./2_Clebinepage.js";
import Smartdrone from "./3_Smartdronepage.jsx";
import Management from "./4_Managementpage.js";
import { API_BASE_URL } from "./Components/constants";

// Auth components
import LoginPage from "./Components/Auth/LoginPage.js";
import RegisterPage from "./Components/Auth/RegisterPage.js";
import PrivateRoute from "./Components/Auth/PrivateRoute.js";
import RecoveryPage from "./Components/Auth/RecoveryPage.js";
import PrivacyPolicyPage from "./Components/Auth/PrivacyPolicyPage.jsx";
import AdminUsersPage from "./Components/Admin/AdminUsersPage.jsx";
import AdminTest from "./Components/Admin/AdminTest.jsx";
import { DemoScenarioProvider } from "./demo/DemoScenarioContext";

const theme = createTheme();

function App() {
  const [tableData, setTableData] = useState([]);
  const [backendStatus, setBackendStatus] = useState("unknown");
  const location = useLocation();

  const handleDataUploaded = (newData) => {
    setTableData((prevData) => [...prevData, ...newData]);
  };

  const handleDelete = (id) => {
    setTableData((prevData) => prevData.filter((row) => row.id !== id));
  };

  // 로그인/회원가입 페이지인지 확인
  const isAuthPage =
    location.pathname === "/login" ||
    location.pathname === "/register" ||
    location.pathname === "/privacy";

  useEffect(() => {
    let cancelled = false;
    let timerId = null;

    const checkBackend = async () => {
      try {
        const res = await fetch(`${API_BASE_URL}/api/db-check`, {
          cache: "no-store",
        });
        if (res.ok || res.status === 401) {
          if (!cancelled) setBackendStatus("ready");
          return;
        }
      } catch (error) {
        // ignore and retry
      }

      if (!cancelled) {
        setBackendStatus("down");
        timerId = setTimeout(checkBackend, 1500);
      }
    };

    checkBackend();

    return () => {
      cancelled = true;
      if (timerId) clearTimeout(timerId);
    };
  }, []);

  if (backendStatus === "down") {
    return (
      <ThemeProvider theme={theme}>
        <div className="app-loading-screen">
          <img src={`${process.env.PUBLIC_URL || ""}/loading.gif`} alt="loading" />
        </div>
      </ThemeProvider>
    );
  }

  return (
    <ThemeProvider theme={theme}>
      <DemoScenarioProvider>
      <div className={`App ${isAuthPage ? "" : "grid-container"}`}>
        {/* 라우트 설정 */}
        <Routes>
          {/* Public routes */}
          <Route path="/login" element={<LoginPage />} />
          <Route path="/register" element={<RegisterPage />} />
          <Route path="/recovery" element={<RecoveryPage />} />
          <Route path="/privacy" element={<PrivacyPolicyPage />} />

          {/* Protected routes */}
          <Route
            path="/"
            element={
              <PrivateRoute>
                <Smartdrone />
              </PrivateRoute>
            }
          />
          <Route
            path="/admin"
            element={
              <PrivateRoute>
                {/* <AdminUsersPage /> */}
                <AdminTest />
              </PrivateRoute>
            }
          />
          <Route path="*" element={<Navigate to="/" replace />} />
          {/* <Route 
            path="/clebinepage" 
            element={
              <PrivateRoute>
                <Clebine 
                  tableData={tableData} 
                  onDelete={handleDelete} 
                  handleDataUploaded={handleDataUploaded} 
                />
              </PrivateRoute>
            } 
          />
          <Route path="/Smartdronepage" element={
            <PrivateRoute>
              <Smartdrone />
            </PrivateRoute>
          } />
          <Route path="/managementpage" element={
            <PrivateRoute>
              <Management />
            </PrivateRoute>
          } />*/}
        </Routes>
      </div>
      </DemoScenarioProvider>
    </ThemeProvider>
  );
}

export default App;
